( function () {
	/* eslint no-undef:0 */
	'use strict';

	function AddEditTextController ( $rootScope, logger, moment, evidence, observation, level, $modalInstance, apiService ) {
		var self = this;

		function closeView () {
			$modalInstance.close();
		}

		function saveEvidence () {
			if ( !level.evidences ) {
				level.evidences = [ ];
			}

			level.evidences.push( angular.copy( self.evidence ) );

			if ( !observation.masterEvidences ) {
				observation.masterEvidences = [ ];
			}

			observation.masterEvidences.push( angular.copy( self.evidence ) );

			self.closeView();
		}

		function cancelChanges () {
			$modalInstance.dismiss();
		}

		function activate () {
			logger.info( 'Activated New Observation View' );

			self.evidence = {
				'id'    : apiService.generateUUID(),
				'name'  : '',
				'type'  : 4,
				'scope' : 'public'
			};
		}

		self.saveEvidence  = saveEvidence;
		self.closeView     = closeView;
		self.cancelChanges = cancelChanges;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'AddEditTextController', AddEditTextController );

	AddEditTextController.$inject = [ '$rootScope', 'logger', 'moment', 'evidence', 'observation', 'level', '$modalInstance', 'apiService' ];
} )( );
